export default "__VITE_ASSET__CPfIr9Aj__"